module.exports = __webpack_public_path__ + "static/media/Formato_Cargar_Proveedores.2db98419.xlsx";